let config: Record<string, string> = {};

export async function loadConfig() {
  try {
    const response = await fetch("/config.json");

    if (!response.ok) {
      throw new Error("Failed to fetch config.json");
    }

    config = await response.json();
  } catch (error) {
    console.error("Failed to fetch config.json");
    throw error;
  }
}

export function getConfig() {
  return config;
}
